export default "__VITE_ASSET__LtWWVxfH__"